import { AxiosAuthenticationHeadersBuilder } from "./axios-authentication-headers-builder";
import { AuthenticationRepository } from "@src/cloud-connect/node-manager/authentication/authentication-repository";

export const buildAxiosAuthenticationHeaders = (): Record<string, string> => {
  const builder = new AxiosAuthenticationHeadersBuilder(
    new AuthenticationRepository(),
  );
  return builder.build();
};

export const buildAxiosAuthenticationHeadersForMultipart = (): Record<
  string,
  string
> => {
  const builder = new AxiosAuthenticationHeadersBuilder(
    new AuthenticationRepository(),
  );
  return builder.buildForMultipart();
};
